import { useMountEffect } from "@react-hookz/web";
import { useSetAtom } from "jotai";
import { brandingImageTypeAtom } from "../store";

export const useResetBrandingImageType = (): void => {
  const setBrandingImageType = useSetAtom(brandingImageTypeAtom);

  useMountEffect(() => setBrandingImageType("square"));
};
